"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELoyaltyCoupons = exports.ELoyaltyStatus = exports.EChangePassword = exports.EAuthenticationSteps = void 0;
var EAuthenticationSteps;
(function (EAuthenticationSteps) {
    EAuthenticationSteps["ONE"] = "one";
    EAuthenticationSteps["TWO"] = "two";
    EAuthenticationSteps["THREE"] = "three";
})(EAuthenticationSteps || (exports.EAuthenticationSteps = EAuthenticationSteps = {}));
var EChangePassword;
(function (EChangePassword) {
    EChangePassword["OLD"] = "oldPassword";
    EChangePassword["RENEWED"] = "newPassword";
    EChangePassword["CONFIRM"] = "confirmPassword";
})(EChangePassword || (exports.EChangePassword = EChangePassword = {}));
var ELoyaltyStatus;
(function (ELoyaltyStatus) {
    ELoyaltyStatus["ALL"] = "ALL";
    ELoyaltyStatus["ACTIVE"] = "ACTIVE";
    ELoyaltyStatus["ARCHIVE"] = "ARCHIVE";
})(ELoyaltyStatus || (exports.ELoyaltyStatus = ELoyaltyStatus = {}));
var ELoyaltyCoupons;
(function (ELoyaltyCoupons) {
    ELoyaltyCoupons["SUITABLE"] = "suitable";
    ELoyaltyCoupons["UNSUITABLE"] = "unsuitable";
})(ELoyaltyCoupons || (exports.ELoyaltyCoupons = ELoyaltyCoupons = {}));
//# sourceMappingURL=types.js.map